import type { SVGProps } from 'react'

const RealTimeInventoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M29.0177 43.7153H20C17.2386 43.7153 15 41.4767 15 38.7153V20.6799C15 17.9185 17.2386 15.6799 20 15.6799H38.0354C40.7968 15.6799 43.0354 17.9185 43.0354 20.6799V29.6976"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9736 16.1214C24.9736 16.0544 25.028 16 25.095 16H33.0664V23.9713C33.0664 24.6577 32.5099 25.2142 31.8235 25.2142H26.2165C25.5301 25.2142 24.9736 24.6577 24.9736 23.9713V16.1214Z"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M44.3099 34.7432V38.3221H40.731"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.8141 41.3062C42.4264 42.4037 41.6924 43.3455 40.7229 43.9896C39.7534 44.6337 38.6007 44.9452 37.4387 44.8772C36.2767 44.8092 35.1683 44.3654 34.2805 43.6127C33.3927 42.8599 32.7735 41.839 32.5164 40.7038C32.2593 39.5686 32.3781 38.3805 32.8549 37.3187C33.3318 36.2568 34.1408 35.3788 35.1601 34.8167C36.1794 34.2547 37.3537 34.0392 38.5062 34.2026C39.6587 34.3661 40.7268 34.8997 41.5496 35.723L44.3113 38.3237"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default RealTimeInventoryIcon
